export class Company {
  id: number;
  code: string;
  name: string;
  image: string;
  insAt: string;
}
